import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Intercom from 'react-intercom';

import { makeSelectUser } from 'reducers/user/selectors';

class IntercomWithUser extends Component {
  static propTypes = {
    user: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  };

  buildIntercomData = () => {
    const { user } = this.props;
    const data = { appID: window._env_.INTERCOM_APP_ID };

    if (!user) {
      return data;
    }

    return {
      ...data,
      name: user.get('name'),
      email: user.get('email'),
      created_at: user.get('created'),
      userType: user.get('userType'),
      user_hash: user.get('userHash'),
      introducerType: user.get('introducerType'),
      consultant: user.get('consultant'),
      company: {
        id: user.getIn(['company', 'company_id']),
        name: user.getIn(['company', 'name']),
        plan: user.getIn(['membership', 'level', 'name']),
      },
    };
  };

  render() {
    if (!window._env_.INTERCOM_ACTIVE) {
      return null;
    }

    return <Intercom {...this.buildIntercomData()} />;
  }
}

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
});

export default connect(mapStateToProps)(IntercomWithUser);
